// extracted by mini-css-extract-plugin
module.exports = {"title":"workwrapper-module--title--3Bste","link":"workwrapper-module--link--2YCdb","line":"workwrapper-module--line--2Hxkb"};